"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDerivedStateFromInitialFilters = getDerivedStateFromInitialFilters;
exports.onItemClick = onItemClick;
exports.toggleFilter = toggleFilter;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function onItemClick(item, filter, setFilterAreaState, setShouldUpdateFilters, setFiltersChanged) {
  setFilterAreaState(previousState => {
    let nextState = _lodash.default.cloneDeep(previousState);
    let filterIndex = nextState.findIndex(e => e.id === filter.id);
    if (filterIndex >= 0) {
      let itemIndex = nextState[filterIndex].items.findIndex(e => e.id === item.id);
      nextState[filterIndex].items[itemIndex].active = !nextState[filterIndex].items[itemIndex].active;
    }
    return nextState;
  });
  if (!filter.isOpen) {
    setShouldUpdateFilters(true);
    setFiltersChanged(true);
  } else {
    setFiltersChanged(true);
  }
}
function toggleFilter(filterId, changeStateCallback) {
  changeStateCallback(previousState => {
    let nextState = _lodash.default.cloneDeep(previousState);
    let filterIndex = nextState.findIndex(e => e.id === filterId);
    if (filterIndex >= 0) {
      nextState[filterIndex].isOpen = !nextState[filterIndex].isOpen;
    }
    return nextState;
  });
}
function getDerivedStateFromInitialFilters(filters) {
  let derivedState = filters.map(filter => {
    let newFilter = {
      id: filter.id,
      label: filter.label,
      items: filter.items,
      isOpen: false,
      onClose: () => null,
      toggle: () => null,
      onClickItem: () => null
    };
    return newFilter;
  });
  return derivedState;
}